const l = {
  name: "PlayCircleFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM10 8.13147V15.8685L15.8028 12L10 8.13147Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as PlayCircleFill
};
